import { createFileRoute } from "@tanstack/react-router";
import { getCheckins } from "~/fetch/checkins";
import { CardsPage } from "~/components/CardsPage";

export const Route = createFileRoute('/')({
  component: Component,
  loader: () => getCheckins({ data: { page: 1 } }),
});

function Component() {
  const data = Route.useLoaderData();
  return <CardsPage data={data} />;
}
